import {infoColor} from "../../Lib/material-dashboard/assets/jss/material-dashboard-pro-react";

const inlineLoaderStyle = {
    progress: {
        color: infoColor[3],
    }
};

export default inlineLoaderStyle;